/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./category-mirror-btn.vue?vue&type=template&id=05becfab&"
import script from "./category-mirror-btn.vue?vue&type=script&lang=ts&"
export * from "./category-mirror-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports